import { render, staticRenderFns } from "./propertyAccount.vue?vue&type=template&id=525f7851&scoped=true"
import script from "./propertyAccount.vue?vue&type=script&lang=js"
export * from "./propertyAccount.vue?vue&type=script&lang=js"
import style0 from "./propertyAccount.vue?vue&type=style&index=0&id=525f7851&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f7851",
  null
  
)

export default component.exports